import { render, staticRenderFns } from "./EventStatisticLine.vue?vue&type=template&id=70252958&scoped=true&"
import script from "./EventStatisticLine.vue?vue&type=script&lang=js&"
export * from "./EventStatisticLine.vue?vue&type=script&lang=js&"
import style0 from "./EventStatisticLine.vue?vue&type=style&index=0&id=70252958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70252958",
  null
  
)

export default component.exports